export const svCustom = {
  headlines: {
    error: "Ett fel inträffade",
    loginEmail: "Logga in eller skapa ett konto",
    loginEmailNoSignup: "Logga in eller skapa konto",
    loginFinished: "Inloggning lyckades",
    loginPasscode: "Ange engångskoden",
    loginPassword: "Ange lösenord",
    registerAuthenticator: "Passnyckel är valfri",
    registerConfirm: "Skapa ett konto?",
    registerPassword: "Ange ett nytt lösenord",
    otpSetUp: "Konfigurera autentiseringsapp",
    profileEmails: "E-postadresser",
    profilePassword: "Lösenord",
    profilePasskeys: "Passnycklar",
    isPrimaryEmail: "Primär e-postadress",
    setPrimaryEmail: "Ange som primär e-post",
    createEmail: "Ange en ny e-postadress",
    createUsername: "Ange ett nytt användarnamn",
    emailVerified: "Verifierad",
    emailUnverified: "Overifierad",
    emailDelete: "Ta bort",
    renamePasskey: "Byt namn på passnyckel",
    deletePasskey: "Ta bort passnyckel",
    lastUsedAt: "Senast använd",
    createdAt: "Skapad",
    connectedAccounts: "Anslutna konton",
    deleteAccount: "Ta bort konto",
    accountNotFound: "Konto hittades inte",
    signIn: "Logga in eller skapa konto",
    signUp: "Börja med att ange din e-postadress",
    selectLoginMethod: "Välj inloggningsmetod",
    setupLoginMethod: "Välj inloggningsmetod",
    lastUsed: "Senast sedd",
    ipAddress: "IP-adress",
    revokeSession: "Återkalla session",
    profileSessions: "Sessioner",
    mfaSetUp: "Extra skydd är valfritt",
    securityKeySetUp: "Lägg till säkerhetsnyckel",
    securityKeyLogin: "Säkerhetsnyckel",
    otpLogin: "Autentiseringskod",
    renameSecurityKey: "Byt namn på säkerhetsnyckel",
    deleteSecurityKey: "Ta bort säkerhetsnyckel",
    securityKeys: "Säkerhetsnycklar",
    authenticatorApp: "Autentiseringsapp",
    authenticatorAppAlreadySetUp: "Autentiseringsapp är konfigurerad",
    authenticatorAppNotSetUp: "Konfigurera autentiseringsapp",
    trustDevice: "Litar du på den här webbläsaren?",
  },
  texts: {
    enterPasscode: "Ange engångskoden som skickats till din e-post. Kontrollera även skräpposten.",
    enterPasscodeNoEmail: "Ange engångskoden som skickats till din primära e-post. Kontrollera även skräpposten.",
    setupPasskey: "Du kan skapa en passnyckel för snabbare inloggning eller hoppa över detta och aktivera den senare i inställningarna. Biometrisk data lagras endast på dina enheter.",
    createAccount: "Det finns inget konto för \"{emailAddress}\". Vill du skapa ett nytt?",
    otpEnterVerificationCode: "Ange engångskoden från din autentiseringsapp:",
    otpScanQRCode: "Skanna QR-koden med en autentiseringsapp (t.ex. Google Authenticator eller annan TOTP-app). Alternativt kan du ange den hemliga nyckeln manuellt.",
    otpSecretKey: "OTP-hemlig nyckel",
    passwordFormatHint: "Längden måste vara mellan {minLength}–{maxLength} tecken.",
    securityKeySetUp: "Använd en USB-, Bluetooth- eller NFC-säkerhetsnyckel eller din telefon. Anslut eller aktivera nyckeln och följ anvisningarna för att slutföra registreringen.",
    setPrimaryEmail: "Ange denna e-post som primär för kontakt.",
    isPrimaryEmail: "Denna e-post används för kontakt vid behov.",
    emailVerified: "Denna e-post är verifierad.",
    emailUnverified: "Denna e-post är overifierad.",
    emailDelete: "Om du tar bort denna e-post kan den inte längre användas för inloggning.",
    renamePasskey: "Ge passnyckeln ett namn.",
    deletePasskey: "Ta bort denna passnyckel från ditt konto.",
    deleteAccount: "Vill du verkligen ta bort kontot? All data kommer att raderas permanent.",
    noAccountExists: "Det finns inget konto för \"{emailAddress}\".",
    selectLoginMethodForFutureLogins: "Du kan välja inloggningsmetod nu eller hoppa över detta och slutföra profilen först.",
    howDoYouWantToLogin: "Hur vill du logga in?",
    mfaSetUp: "Du kan aktivera MFA nu eller hoppa över detta och konfigurera det senare i inställningarna.",
    securityKeyLogin: "Anslut eller aktivera din säkerhetsnyckel och följ anvisningarna för att slutföra inloggningen.",
    otpLogin: "Öppna din autentiseringsapp och ange engångskoden i fältet.",
    renameSecurityKey: "Ge säkerhetsnyckeln ett namn.",
    deleteSecurityKey: "Ta bort denna säkerhetsnyckel från ditt konto.",
    authenticatorAppAlreadySetUp: "Ditt konto är skyddat med en autentiseringsapp som genererar engångskoder (TOTP).",
    authenticatorAppNotSetUp: "Skydda ditt konto med en autentiseringsapp som genererar engångskoder (TOTP).",
    trustDevice: "Om du litar på den här webbläsaren behöver du inte använda MFA nästa gång du loggar in.",
  },
  labels: {
    or: "eller",
    no: "nej",
    yes: "ja",
    email: "E-post",
    continue: "Fortsätt",
    copied: "kopierad",
    skip: "Hoppa över nu",
    save: "Spara",
    password: "Lösenord",
    passkey: "Passnyckel",
    passcode: "Engångskod",
    signInPassword: "Logga in med lösenord",
    signInPasscode: "Logga in med engångskod",
    forgotYourPassword: "Glömt ditt lösenord?",
    back: "Tillbaka",
    signInPasskey: "Logga in med passnyckel",
    registerAuthenticator: "Skapa en passnyckel",
    signIn: "Logga in",
    signUp: "Skapa konto",
    sendNewPasscode: "Skicka ny kod",
    passwordRetryAfter: "Försök igen om {passwordRetryAfter}",
    passcodeResendAfter: "Begär ny kod om {passcodeResendAfter}",
    unverifiedEmail: "overifierad",
    primaryEmail: "primär",
    setAsPrimaryEmail: "Ange som primär",
    verify: "Verifiera",
    delete: "Ta bort",
    newEmailAddress: "Ny e-postadress",
    newPassword: "Nytt lösenord",
    rename: "Byt namn",
    newPasskeyName: "Nytt namn på passnyckel",
    addEmail: "Lägg till e-post",
    createPasskey: "Skapa passnyckel",
    webauthnUnsupported: "Passnycklar stöds inte i din webbläsare",
    signInWith: "Fortsätt med {provider}",
    deleteAccount: "Ja, ta bort detta konto.",
    emailOrUsername: "E-post eller användarnamn",
    username: "Användarnamn",
    optional: "valfritt",
    dontHaveAnAccount: "Har du inget konto?",
    alreadyHaveAnAccount: "Har du redan ett konto?",
    changeUsername: "Byt användarnamn",
    setUsername: "Ange användarnamn",
    changePassword: "Byt lösenord",
    setPassword: "Ange lösenord",
    revoke: "Återkalla",
    currentSession: "Nuvarande session",
    authenticatorApp: "Autentiseringsapp",
    securityKey: "Säkerhetsnyckel",
    securityKeyUse: "Använd säkerhetsnyckel",
    newSecurityKeyName: "Nytt namn på säkerhetsnyckel",
    createSecurityKey: "Lägg till säkerhetsnyckel",
    authenticatorAppManage: "Hantera autentiseringsapp",
    authenticatorAppAdd: "Konfigurera",
    configured: "konfigurerad",
    useAnotherMethod: "Använd en annan metod",
    lastUsed: "Senast använd",
    trustDevice: "Lita på den här webbläsaren",
    staySignedIn: "Förbli inloggad",
  },
  errors: {
    somethingWentWrong: "Ett tekniskt fel inträffade. Försök igen senare.",
    requestTimeout: "Tidsgränsen för begäran överskreds.",
    invalidPassword: "Felaktig e-post eller lösenord.",
    invalidPasscode: "Den angivna engångskoden är felaktig.",
    passcodeAttemptsReached: "För många felaktiga försök. Begär en ny kod.",
    tooManyRequests: "För många förfrågningar. Vänta innan du försöker igen.",
    unauthorized: "Sessionen har löpt ut. Logga in igen.",
    invalidWebauthnCredential: "Denna passnyckel kan inte längre användas.",
    passcodeExpired: "Engångskoden har löpt ut. Begär en ny.",
    userVerification: "Användarverifiering krävs. Se till att din enhet är skyddad med en PIN-kod eller biometrisk identifiering.",
    emailAddressAlreadyExistsError: "E-postadressen används redan.",
    maxNumOfEmailAddressesReached: "Du kan inte lägga till fler e-postadresser.",
    thirdPartyAccessDenied: "Åtkomst nekad. Användaren avbröt begäran eller tjänsteleverantören blockerade åtkomsten.",
    thirdPartyMultipleAccounts: "Kontot kunde inte identifieras. E-postadressen är kopplad till flera konton.",
    thirdPartyUnverifiedEmail: "E-postverifiering krävs. Verifiera din e-post via din tjänsteleverantör.",
    signupDisabled: "Kontoskapande är inaktiverat.",
    handlerNotFoundError: "Det aktuella steget stöds inte i denna applikationsversion. Försök igen senare eller kontakta support.",
  },
  flowErrors: {
    technical_error: "Ett tekniskt fel inträffade. Försök igen senare.",
    flow_expired_error: "Sessionen har löpt ut, starta om genom att trycka på knappen.",
    value_invalid_error: "Det angivna värdet är ogiltigt.",
    passcode_invalid: "Den angivna engångskoden är felaktig.",
    passkey_invalid: "Denna passnyckel kan inte längre användas.",
    passcode_max_attempts_reached: "För många felaktiga försök. Begär en ny kod.",
    rate_limit_exceeded: "För många förfrågningar. Vänta innan du försöker igen.",
    unknown_username_error: "Användarnamnet identifierades inte.",
    unknown_email_error: "E-postadressen identifierades inte.",
    username_already_exists: "Användarnamnet används redan.",
    invalid_username_error: "Användarnamnet får endast innehålla bokstäver, siffror och understreck.",
    email_already_exists: "E-postadressen används redan.",
    not_found: "Den begärda resursen hittades inte.",
    operation_not_permitted_error: "Åtgärden är inte tillåten.",
    flow_discontinuity_error: "Processen kan inte fortsätta på grund av användarinställningar eller leverantörskonfigurationer.",
    form_data_invalid_error: "Det finns fel i formulärdata.",
    unauthorized: "Sessionen har löpt ut. Logga in igen.",
    value_missing_error: "Värdet saknas.",
    value_too_long_error: "Värdet är för långt.",
    value_too_short_error: "Värdet är för kort.",
    webauthn_credential_invalid_mfa_only: "Denna autentiserare kan endast användas som en tvåstegs-säkerhetsnyckel.",
    webauthn_credential_already_exists: "Tidsgränsen för begäran överskreds, begäran avbröts eller enheten är redan registrerad. Försök igen eller använd en annan enhet.",
    platform_authenticator_required: "Ditt konto kräver plattformsspecifika autentiseringsenheter, men din nuvarande enhet eller webbläsare stöder dem inte. Försök med en annan enhet eller webbläsare.",
    third_party_access_denied: "Åtkomst nekad. Användaren avbröt begäran eller tjänsteleverantören blockerade åtkomsten.",
  }
};
